import React from 'react';
import Layout from '../layout';
import AndiHero from '../assets/v2/homepage/homepageHero2@3x.png';
import PartnersHomepage from '../components/Esper/PartnersHomepage';

import ProductSectionOne from '../components/Esper/Product/ProductSectionOne';
import ProductSectionTwo from '../components/Esper/Product/ProductSectionTwo';
import ProductSectionThree from '../components/Esper/Product/ProductSectionThree';
import ProductSectionFour from '../components/Esper/Product/ProductSectionFour';
import ProductSectionFive from '../components/Esper/Product/ProductSectionFive';
import ProductSectionSix from '../components/Esper/Product/ProductSectionSix';
import ProductSectionSeven from '../components/Esper/Product/ProductSectionSeven';

import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    messages={messages}
    ogImage={AndiHero}
    keywords={`Android DevOps, enterprise device management , Future of MDM solutions, android enterprise device management`}
    description={
      'Esper is the first platform built for Android enterprise device management and DevOps, so you can deploy devices, manage apps, and secure your fleet.'
    }
    title={'The Future of MDM is Here | Move to Android DevOps'}
    className="first-page"
    location={props.location}
  >
    <ProductSectionOne messages={messages} />
    <ProductSectionTwo messages={messages} />
    <ProductSectionThree messages={messages} />
    <ProductSectionFour messages={messages} />
    <ProductSectionFive messages={messages} />
    <PartnersHomepage
      companies={['google', 'zebra', 'lenovo', 'mediatek']}
      title={messages?.HomePageOurPartners ?? `Our Partners`}
    />
    <ProductSectionSix messages={messages} />
    <ProductSectionSeven messages={messages} />
  </Layout>
);
